<!--
	充值
	lovi 2019-12-30
-->
<template>
  <div>
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("wallet.cashIn") }}</BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" @click="returnFun" v-if="stepIndex > 0">
        {{ $t("common.back") }}
      </a>
    </div>
    <div class="step-wrap">
      <div class="stepCon active">
        <p class="stepTxt">1.{{ $t("recharge.fillAmount") }}</p>
      </div>
      <div class="stepCon" :class="{ active: stepIndex >= 1 }">
        <div class="step active"></div>
        <p class="stepTxt">2.{{ $t("recharge.confirmPay") }}</p>
      </div>
      <div class="stepCon" :class="{ active: stepIndex == 2 }">
        <div class="step" :class="{ active: stepIndex >= 1 }"></div>
        <p class="stepTxt">3.{{ $t("common.done") }}</p>
      </div>
    </div>
    <!-- 第一步 Start -->
    <template v-if="stepIndex == 0">
      <div class="global-dl first-step">
        <dl>
          <dt>{{ $t("wallet.rechargeAmount") }}：</dt>
          <dd>
            <div class="money-wrap">
              <div
                class="money-item"
                v-for="(item, index) in moneyList"
                :key="index"
                :class="
                  (quick_amount == null && item.is_default == 1) ||
                  quick_amount == item.piso_value
                    ? 'active'
                    : ''
                "
                @click="changeMoney(item.piso_value)"
              >
                <h3>{{ item.piso_value }}P</h3>
                <p v-if="curPay.exchange_rate">
                  {{ $t("common.price") }}
                  {{
                    curPay.exchange_rate
                      ? _PHPtoRMB(item.piso_value, curPay.exchange_rate)
                      : ""
                  }}
                  {{ $t("common.CNY") }}
                </p>
              </div>
            </div>
            <div class="custom-money">
              <span>{{ $t("wallet.customizedAmount") }}：</span>
              <InputNumber
                v-model="enter_amount"
                :min="0"
                @on-change="inputAmount"
                :precision="2"
                :placeholder="$t('common.enterAmount')"
              />
              <span>P</span>
            </div>
          </dd>
        </dl>
        <!-- 选择支付方式 -->
        <pay-list @getCurPay="getCurPay" :type="1"></pay-list>
      </div>
      <div class="button-wrap">
        <Button
          type="primary"
          long
          @click="nextStepFun"
          :loading="nextStepLoad"
        >
          {{ $t("common.nextStep") }}
        </Button>
      </div>
    </template>
    <!-- 第一步 End -->
    <!-- 第二步 Start -->
    <template v-if="stepIndex == 1">
      <!-- 微信支付 -->
      <pay-code
        v-if="curPay.payment_id == 5"
        :money="money"
        :type="curPay.payment_id"
        :data="payMentInfo"
        @getPayCode="getPayCode"
      />
      <!-- 7.线下现金、8.线下银行卡 -->
      <template v-if="curPay.payment_id == 7 || curPay.payment_id == 8">
        <div class="pay-two">
          <template v-if="curPay.payment_id == 8">
            <select-bank
              v-if="selectBankFlag"
              :selectBankFlag.sync="selectBankFlag"
              :list="bankCardList"
              :bank.sync="bank"
              :params="bankCardParams"
              @getBankInfo="getBankInfo"
            />
            <template v-else>
              <img class="bank-logo" :src="httpUrl + offPayData.icon" />
              <h3>{{ curPay.name }}</h3>
              <div class="table">
                <table cellspacing="1">
                  <tr>
                    <td>
                      {{ $t("wallet.openingBank") }}：{{ bank.bank_name }}
                    </td>
                    <td>
                      {{ $t("wallet.rechargeAmount") }}：
                      <span class="text-red">
                        {{ money }}P
                        <template v-if="bank.country == 1 || bank.country == 3">
                          /
                          {{
                            _PHPtoRMB(
                              parseFloat(money),
                              parseFloat(bank.exchange_rate)
                            )
                          }}
                          {{
                            bank.country == 1
                              ? "RMB"
                              : bank.country == 3
                              ? "VND"
                              : ""
                          }}
                        </template>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t("wallet.accountNumber") }}：{{ bank.bank_username }}
                    </td>
                    <td>
                      {{ $t("wallet.additionalCode") }}：
                      <span class="text-red">{{
                        offPayData.additional_code
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t("wallet.bankCardNumber") }}：{{ bank.card_number }}
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </template>
          </template>
          <template v-else>
            <img class="bank-logo" :src="httpUrl + offPayData.icon" />
            <h3>{{ curPay.name }}</h3>
            <div class="table">
              <table cellspacing="1" style="text-align: center;">
                <tr>
                  <td>
                    {{ $t("wallet.rechargeAmount") }}：
                    <span class="text-red">{{ money }}P</span>
                  </td>
                  <td>
                    {{ $t("wallet.additionalCode") }}：
                    <span class="text-red">
                      {{ offPayData.additional_code }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </template>
        </div>
        <div class="button-wrap" v-if="!selectBankFlag">
          <Button
            type="primary"
            long
            @click="confirmFun"
            :loading="nextStepLoad"
          >
            {{ $t("wallet.completePayment") }}
          </Button>
        </div>
      </template>
    </template>
    <!-- 第二步 End -->
    <!-- 第三步 Start -->
    <template v-if="stepIndex == 2">
      <!-- 微信支付 -->
      <detail
        v-if="curPay.payment_id == 5 && detailFlag"
        :detailFlag.sync="detailFlag"
        :order_id="payMentInfo.order_id"
        :type="1"
      />
      <!-- 7.线下现金、8.线下银行卡 -->
      <template v-if="curPay.payment_id == 7 || curPay.payment_id == 8">
        <div class="pay-three">
          <img class="state" src="@/assets/images/public/icon_success@2x.png" />
          <h3>{{ $t("wallet.successfullySubmitted") }}</h3>
          <div class="table">
            <table cellspacing="1">
              <tr>
                <td>{{ $t("wallet.rechargeType") }}：{{ curPay.name }}</td>
                <td>
                  {{ $t("wallet.rechargeAmount") }}：
                  <span class="text-red">
                    {{ money }}P
                    <template
                      v-if="
                        curPay.payment_id == 8 &&
                          (bank.country == 1 || bank.country == 3)
                      "
                    >
                      /
                      {{
                        _PHPtoRMB(
                          parseFloat(money),
                          parseFloat(bank.exchange_rate)
                        )
                      }}
                      {{
                        bank.country == 1
                          ? "RMB"
                          : bank.country == 3
                          ? "VND"
                          : ""
                      }}
                    </template>
                  </span>
                </td>
                <td>
                  {{ $t("wallet.additionalCode") }}：
                  <span class="text-red">{{ offPayData.additional_code }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="button-wrap">
          <Button type="primary" long @click="returnFun">
            {{ $t("common.done") }}
          </Button>
          <p>
            {{ $t("wallet.topUpTips") }}
          </p>
        </div>
      </template>
    </template>
    <!-- 第三步 End -->
  </div>
</template>

<script>
import PayList from "@/components/payList";
import PayCode from "@/components/payCode";
import SelectBank from "./selectBank";
import Detail from "@/components/detail";
export default {
  name: "wallet-recharge",
  components: {
    PayList,
    PayCode,
    SelectBank,
    Detail
  },
  data() {
    return {
      rechargeInfo: {}, //充值信息
      moneyList: [], //快捷金额
      stepIndex: 0, //第几步
      curPay: {}, //当前支付方式
      money: "",
      quick_amount: "", //快捷金额
      enter_amount: null, //输入金额
      payList: [], //支付列表
      nextStepLoad: false, //下一步load
      payMentInfo: {}, //微信支付宝支付信息
      offPayData: {}, //线下支付信息
      detailFlag: false, //微信支付宝详情Flag
      bankCardList: [], //银行卡列表
      exchange: "",
      selectBankFlag: false,
      bank: {}
    };
  },
  created() {
    this._getRechargeInfo();
    this.$store.dispatch("GET_USER_INFO");
  },
  mounted() {},
  computed: {},
  methods: {
    returnFun() {
      // 返回按钮
      this.stepIndex = 0;
      this.bank = {};
      this._getRechargeInfo();
    },
    changeMoney(item) {
      // 金额面板
      this.enter_amount = null;
      this.quick_amount = parseFloat(item);
    },
    inputAmount() {
      //输入金额
      this.quick_amount = "";
    },
    getCurPay(data) {
      // 获取当前支付信息
      this.curPay = data;
    },
    nextStepFun() {
      // 下一步
      let vm = this;
      if (vm.quick_amount == "" && vm.enter_amount == null) {
        vm.$Message.warning(vm.$t("common.enterAmount"));
        return;
      }
      // if (Number(vm.enter_amount)) {
      //   if (Number(vm.enter_amount) < Number(vm.rechargeInfo.min)) {
      //     vm.$Message.info(
      //       vm.$t("common.customized") +
      //         vm.$t("common.amountCannotMin") +
      //         vm.rechargeInfo.min
      //     );
      //     return;
      //   }
      //   if (Number(vm.enter_amount) > Number(vm.rechargeInfo.max)) {
      //     vm.$Message.info(
      //       vm.$t("common.customized") +
      //         vm.$t("common.amountCannotMax") +
      //         vm.rechargeInfo.max
      //     );
      //     return;
      //   }
      // }
      let money = vm.quick_amount || vm.enter_amount;
      if (money < 0) {
        vm.$Message.warning(vm.$t("common.enterCorrectAmount"));
        return;
      }
      vm.money = Number(money).toFixed(2);
      // if (vm.money == "" || vm.money == null) {
      //   vm.money = 0;
      //   for (let i = 0; i < vm.moneyList.length; i++) {
      //     if (vm.moneyList[i].is_default == 1) {
      //       vm.money = vm.moneyList[i].piso_value;
      //       break;
      //     }
      //   }
      // }
      let params = {};
      params.payment_id = vm.curPay.payment_id; // 支付方式，5.微信扫码支付、7.线下现金、8.线下银行卡
      params.money = vm.money;
      // params.detail = "余额充值";
      if (vm.curPay.payment_id == 5) {
        // 5.微信扫码支付
        vm.payment(params);
      }
      if (vm.curPay.payment_id == 7) {
        // 7.线下现金
        vm.offLine(params);
      }
      if (vm.curPay.payment_id == 8) {
        // 8.线下银行卡
        vm.bankCardParams = params;
        console.log("bankCardParams", params);
        vm.getBankList();
      }
    },
    payment(params) {
      // 微信扫码支付
      let vm = this;
      vm.$post("/app/pay/payment", params, { loading: true }).then(res => {
        console.log("payment", res);
        vm.payMentInfo = res;
        vm.stepIndex = 1;
      });
    },
    getPayCode() {
      // 详情
      this.stepIndex = 2;
      this.detailFlag = true;
    },
    offLine(params) {
      // 线下现金
      let vm = this;
      vm.$post("/app/pay/cash_pay", params, { loading: true }).then(res => {
        console.log("cash_pay", res);
        vm.offPayData = res;
        vm.stepIndex = 1;
      });
    },
    getBankInfo(data) {
      // 获取银行卡充值信息
      console.log("getBankInfo", data);
      this.offPayData.additional_code = data.additional_code;
      this.offPayData.money = data.money;
      this.offPayData.icon = data.icon;

      this.bank.bank_id = data.bank_id;
      this.bank.bank_name = data.bank_name;
      this.bank.bank_username = data.bank_username;
      this.bank.card_number = data.card_number;
      this.bank.country = data.country;
      this.bank.exchange_rate = data.exchange_rate;
      this.bank.exchange_rate_show = data.exchange_rate_show;
    },
    confirmFun() {
      // 完成支付
      let vm = this;
      vm.$post(
        "/app/pay/complete_pay",
        { code: vm.offPayData.additional_code },
        { loading: true }
      ).then(res => {
        console.log("complete_pay", res);
        vm.nextStepLoad = false;
        vm.stepIndex = 2;
      });
    },
    getBankList() {
      // 获取银行卡列表
      let vm = this;
      vm.$post("/app/pay/bankList", {}, { loading: true }).then(res => {
        console.log("bankList", res);
        vm.bankCardList = res;
        vm.stepIndex = 1;
        vm.selectBankFlag = true;
      });
    },
    _getRechargeInfo() {
      // 获取快捷金额
      let vm = this;
      vm.$post(
        "/app/accountrecharge/rechargeBalanceMainInfo",
        {},
        { loading: true }
      ).then(res => {
        console.log("rechargeBalanceMainInfo", res);
        vm.rechargeInfo = res;
        vm.moneyList = res.recharge_money_list;
        for (var i = 0; i < vm.moneyList.length; i++) {
          if (vm.moneyList[i].is_default == 1) {
            vm.money = vm.moneyList[i].piso_value;
          }
        }
      });
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
.first-step {
  padding: 20px 0;
  dl {
    margin-bottom: 20px;
  }
  .custom-money {
    margin-top: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.ivu-input-number {
      margin: 0 10px;
    }
    /deep/.ivu-input-wrapper,
    /deep/.ivu-input-number {
      font-size: 14px;
      width: 200px;
    }
  }
  .money-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: -10px;
    .money-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;
      cursor: pointer;
      margin-right: 15px;
      margin-top: 10px;
      padding: 5px 10px;
      text-align: center;
      min-width: 88px;
      height: 60px;
      color: #666;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      &.active {
        color: #fff;
        border-color: #2043ac;
        background: linear-gradient(
          90deg,
          rgba(32, 67, 172, 1) 0%,
          rgba(19, 15, 115, 1) 100%
        );
      }
      &:hover {
        border-color: #2043ac;
      }
      img {
        vertical-align: middle;
        margin-right: 8px;
        width: 30px;
        height: 30px;
      }
    }
  }
}

.table {
  margin-top: 20px;
  table {
    width: 100%;
    padding: 0;
    text-align: left;
    background: #e6e6e6;
    td {
      padding: 5px 10px;
      font-size: 16px;
      line-height: 30px;
      word-break: break-all;
      background: #fff;
    }
  }
}

.pay-two {
  margin: 20px 100px;
  text-align: center;
  .bank-logo {
    max-width: 200px;
    max-height: 80px;
  }
  h3 {
    margin-top: 10px;
    font-size: 20px;
    font-weight: 500;
  }
}

.pay-three {
  padding: 20px 0;
  text-align: center;
  .state {
    width: 110px;
  }
  h3 {
    margin-top: 10px;
    font-size: 20px;
    font-weight: 500;
  }
}
</style>
